import { InputHTMLAttributes } from 'react'

import { Control, Controller } from 'react-hook-form'

import { InputText } from '@interco/inter-toranja'

import { LeadFormData, LeadFormValues } from './schema'

type TextFieldName = 'firstName' | 'lastName' | 'phone' | 'email' | 'purchasePrice'

type FormInputFieldProps = {
  name: TextFieldName
  control: Control<LeadFormValues, unknown, LeadFormData>
  isSubmitted: boolean
  label: string
  placeholder: string
  inputMode?: InputHTMLAttributes<HTMLInputElement>['inputMode']
  mask?: 'phone'
  prefix?: string
  formatValue?: (value: string) => string
  parseChange?: (value: string) => string
}

export function FormInputField({
  name,
  control,
  isSubmitted,
  label,
  placeholder,
  inputMode,
  mask,
  prefix,
  formatValue,
  parseChange,
}: FormInputFieldProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <InputText
          label={label}
          placeholder={placeholder}
          inputMode={inputMode}
          mask={mask}
          prefix={prefix}
          value={formatValue ? formatValue(field.value) : field.value}
          onChange={(value) => field.onChange(parseChange ? parseChange(value) : value)}
          onBlur={field.onBlur}
          state={fieldState.error && isSubmitted ? 'error' : 'enabled'}
          error={fieldState.error && isSubmitted ? [fieldState.error.message ?? ''] : undefined}
          showClear={fieldState.error && isSubmitted}
        />
      )}
    />
  )
}
